import {
  normalizeCity,
  normalizeIndustry,
} from "../../../utils/filterNormalization";
import {
  formatSectorLabel,
} from "../../../constants/sectors";

export const PIPELINE_STAGE_OPTIONS = [
  "Needs Outreach",
  "Engaged",
  "Support In Progress",
  "At Risk",
  "Out of Business",
];

export const createEmptyBRECompany = () => ({
  name: "",
  industry: "",
  sector: "",
  phone_number: "",
  city: "",
  county: "",
  state: "",
  zip_code: "",
  country: "",
  number_of_employees: "",
  industries_served: "",
  geographic_markets_covered: "",
  website: "",
  description: "",
  data_source: "",
  address: "",
  linkedin: "",
  annual_revenue: "",
  lease_expiration: "",
  twitter: "",
  facebook: "",
  naics_text: "",
  naics_code: "",
  industry_custom: "",
  pipeline_stage: "",
  added_to_external_db: false,
  external_db_added_at: null,
  lease_document_name: "",
  lease_document_uploaded_at: null,
  lease_documents: [],
});

const toNullIfBlank = (value) =>
  value === "" || value === undefined || value === null ? null : value;

const asIntOrNull = (value) => {
  const parsed = parseInt(String(value ?? "").replace(/[, ]/g, ""), 10);
  return Number.isFinite(parsed) ? parsed : null;
};

const asFloatOrNull = (value) => {
  const parsed = parseFloat(String(value ?? "").replace(/[, ]/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
};

export const normalizePipelineStageFilter = (value) => {
  if (!value || value === "null") {
    return "";
  }

  return value;
};

export const normalizeCityLabel = (value) => normalizeCity(value);
export const normalizeIndustryLabel = (value) => normalizeIndustry(value);
export const formatBroadSectorLabel = (value) => formatSectorLabel(value);
export const formatBRELocationLabel = ({ city, state }) => {
  const normalizedCity = normalizeCityLabel(city);
  const normalizedState = state?.trim?.();
  const parts = [normalizedCity, normalizedState].filter(Boolean);

  return parts.length > 0 ? parts.join(", ") : "-";
};

export const hydrateBRECompanyForm = (data = {}) => ({
  ...createEmptyBRECompany(),
  ...data,
  name: data.name || "",
  industry: data.industry || "",
  sector: data.sector || "",
  phone_number: data.phone_number || "",
  city: data.city || "",
  county: data.county || "",
  state: data.state || "",
  zip_code: data.zip_code || "",
  country: data.country || "",
  naics_text: data.naics_text || "",
  naics_code: data.naics_code || "",
  industry_custom: data.industry_custom || "",
  number_of_employees:
    data.number_of_employees != null ? String(data.number_of_employees) : "",
  industries_served: data.industries_served || "",
  geographic_markets_covered: data.geographic_markets_covered || "",
  website: data.website || "",
  description: data.description || "",
  data_source: data.data_source || "",
  address: data.address || "",
  linkedin: data.linkedin || "",
  annual_revenue:
    data.annual_revenue != null ? String(data.annual_revenue) : "",
  lease_expiration: data.lease_expiration || "",
  twitter: data.twitter || "",
  facebook: data.facebook || "",
  pipeline_stage: data.pipeline_stage || "",
  added_to_external_db: data.added_to_external_db ?? false,
  external_db_added_at: data.external_db_added_at ?? null,
  lease_document_name: data.lease_document_name || "",
  lease_document_uploaded_at: data.lease_document_uploaded_at ?? null,
  lease_documents: Array.isArray(data.lease_documents) ? data.lease_documents : [],
});

export const buildBRECompanyPayload = (company, isNew) => {
  const source = { ...company };

  const finalIndustry =
    source.industry_custom && source.industry_custom.trim() !== ""
      ? source.industry_custom.trim()
      : source.naics_text && source.naics_text.trim() !== ""
        ? source.naics_text.trim()
        : source.industry && source.industry.trim() !== ""
          ? source.industry.trim()
          : null;

  return {
    name: toNullIfBlank(source.name),
    sector: toNullIfBlank(source.sector),
    naics_text: toNullIfBlank(source.naics_text),
    naics_code: toNullIfBlank(source.naics_code),
    industry_custom: toNullIfBlank(source.industry_custom),
    industry: finalIndustry,
    phone_number: toNullIfBlank(source.phone_number),
    city: toNullIfBlank(source.city),
    state: toNullIfBlank(source.state),
    county: toNullIfBlank(source.county),
    zip_code: toNullIfBlank(source.zip_code),
    country: toNullIfBlank(source.country),
    number_of_employees: asIntOrNull(source.number_of_employees),
    industries_served: toNullIfBlank(source.industries_served),
    geographic_markets_covered: toNullIfBlank(source.geographic_markets_covered),
    website: toNullIfBlank(source.website),
    description: toNullIfBlank(source.description),
    data_source: isNew
      ? "Subscriber Manual Entry"
      : toNullIfBlank(source.data_source),
    address: toNullIfBlank(source.address),
    linkedin: toNullIfBlank(source.linkedin),
    annual_revenue: asFloatOrNull(source.annual_revenue),
    lease_expiration: toNullIfBlank(source.lease_expiration),
    twitter: toNullIfBlank(source.twitter),
    facebook: toNullIfBlank(source.facebook),
  };
};

export const downloadBlobFile = (blobData, filename) => {
  const url = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
